<template>
  <div class="base-mit-header pb-1 pb-sm-5"><!-- default all to 1 but override sm and larger to 8 -->
    <!-- <v-app-bar flat dark color="purple"> -->
    <v-app-bar app clipped-left flat dark>
      <v-app-bar-nav-icon class="hidden-md-and-up" @click="menuOpen = true"></v-app-bar-nav-icon>
      <v-img class="mx-2" src="/assets/csail-tig.png" max-height="40" max-width="140" contain></v-img>
      <v-spacer></v-spacer>
      <v-toolbar-title class="mit-header-title pl-10">{{appName}}</v-toolbar-title>
      <v-spacer></v-spacer>

        <div v-if="!userModel">
          <v-btn class="text-button hidden-sm-and-down" :ripple="false" text @click="login()">Sign In</v-btn>
        </div>
        <div v-if="userModel">
          <v-btn class="text-button hidden-sm-and-down" :ripple="false" text @click="logout()">Sign Out</v-btn>
        </div>

    </v-app-bar>

    <v-navigation-drawer v-model="menuOpen" absolute temporary>
      <BaseMitMenu v-if="userModel" :userModel="userModel" :userRoles="userRoles" v-on:logout="logout" v-on:login="login"/>
    </v-navigation-drawer>
  </div>
</template>

<script>
import BaseMitConfigService from '../services/BaseMitConfigService.js';
import BaseMitMenu from './BaseMitMenu.vue';

export default {
  name: 'BaseMitHeader',
  components: {
    BaseMitMenu
  },
  props: {
    userModel: Object,
    userRoles: Object
  },
  data: function() {
    return {
      menuOpen: false,
      group: null,
      appName: ''
    }
  },
  mounted() {
    this.appName = BaseMitConfigService.get('CLIENT_APP_NAME');
  },
  methods : {
        login(){
          this.$emit('login');
        },
        logout(){
          this.$emit('logout');
        }
  }
}
</script>

<style lang="scss" scoped>
</style>
